/**
 *  @name: private.jsx
 *  @version: 1.0.0
 *  @author: Trejocode - Sergio
 *  @description: Página privada
 */

import React from "react";
import Layout from "../layout";
import Sidebar from "../../components/header/sidebar";
import Entrys from "../../components/inventory/entrysOutput";

const Inventory = () => (
  <Layout
    title="Entradas y Salidas de Artículos"
    description="Página privada de perfil"
    keywords="Reactjs, SEO Ready, Ejemplo"
  >
    <Sidebar />
    <Entrys></Entrys>
  </Layout>
);

export default Inventory;
